/**
 * 状态管理器
 *
 * @ version 1.0.0
 **/
import Vue from 'vue';
import Vuex	from 'vuex';
// 模块
import common from './modules/common';
import user	from './modules/user';
import cart from './modules/cart';

Vue.use(Vuex);

const store = new Vuex.Store({
	modules: {
		common, // 系统初始化
		user, // 用户中心
		cart // 购物车
	}
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js